import React from "react"
import Layout from "../components/Layout"
import Seo from "../components/Seo"

import HeroParallax from '../components/HeroParallax'

const heroText = () => (
    <span>MAXIMISE YOUR <br /> POTENTIAL<br /> WITH US</span>
)

const AboutPage = () => (
    <>
        <Layout>
            <Seo title="About Us" />
            <HeroParallax 
                bgImg="/08.jpg"
                text={heroText()}
                extraStyling=" text-6xl pl-4 pt-48 md:pl-0 md:text-7xl "/>
            <main className="flex flex-wrap md:flex-nowrap px-6">
                <div className="mb-8 md:px-10 md:w-1/2">
                    <h2>Our Company</h2>
                    <p>Knight Recruitment is a boutique recruitment firm that
                    provides customised staffing solutions to MNCs across the
                    Asia Pacific. We focus on the recruitment of middle to
                    senior executive positions in Accounting, Business
                    Administration, E-commerce, Graphic Design, Jewellery
                    Design, Human Resources, Fashion Retail, Luxury Retail,
                    FMCG, Marketing, Translators and Company Secretarial
                    professionals in Hong Kong, China and the rest of
                     the APAC region.</p>
                    
                    <p> At Knight, we take the time to find out what you
                    really need from your next role and offer one-on-one
                    guidance at every stage of the recruitment process
                    to help you reach your career goals.</p>
                </div>
                <div className="mb-8 md:px-10 md:w-1/2">
                    <h2>Our Consultants</h2>
                    <p>At Knight, all of our consultants are highly
                    experienced recruiters within different industries. 
                    We are a small unique team who are committed to
                    excellence. Our team is driven to deliver the best
                    service possible. With a proactive attitude towards
                    tailoring the most suited recruitment solution to your
                    business. We will never stand still and will always
                    look to improve our skills and services.</p>
                </div>
            </main>
        </Layout>
    </>
)

export default AboutPage
